/**
 * Created by mukund on 6/10/15.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('UploadController', function ($scope, Principal) {

        Principal.identity().then(function(account) {
            $scope.account = account;
            $scope.isAuthenticated = Principal.isAuthenticated;
        });
    });

angular.module('mediacloudApp')
    .filter("showPermission", function() {
        return function (items, permission) {
            if(!items || !items.length){ return; }
            return items.filter(function (item) {
                return item.acl.indexOf(permission) > -1;
            });
        };
    });
